// extracted by mini-css-extract-plugin
module.exports = {"joinOurFamSection":"JoinOurFam_joinOurFamSection__NtBi6","ourFamBGImg":"JoinOurFam_ourFamBGImg__9ekus","textBox":"JoinOurFam_textBox__ZNiBz","joinFam":"JoinOurFam_joinFam__ah6DL"};